const HIDE_KEY = 'slbk_ads_hidden_until'
const HIDE_MS = 24 * 60 * 60 * 1000
/** 每次搜索展示广告的概率（偏低，避免打扰） */
const SHOW_CHANCE = 0.28

export function adsAreHidden() {
  try {
    const until = Number(localStorage.getItem(HIDE_KEY) || 0)
    return until > Date.now()
  } catch (e) {
    return false
  }
}

export function hideAdsForAWhile() {
  try {
    localStorage.setItem(HIDE_KEY, String(Date.now() + HIDE_MS))
  } catch (e) {
    /* ignore */
  }
}

export function shouldShowAdsThisSearch() {
  if (adsAreHidden()) return false
  return Math.random() < SHOW_CHANCE
}

/** 按 weight 加权随机抽 n 条，不重复 */
export function pickRandomAds(list, n = 1) {
  const pool = Array.isArray(list) ? [...list] : []
  if (!pool.length || n <= 0) return []
  const out = []
  const take = Math.min(n, pool.length)
  for (let i = 0; i < take; i += 1) {
    const total = pool.reduce((s, a) => s + Math.max(1, Number(a.weight) || 1), 0)
    let r = Math.random() * total
    let idx = 0
    for (let j = 0; j < pool.length; j += 1) {
      r -= Math.max(1, Number(pool[j].weight) || 1)
      if (r <= 0) {
        idx = j
        break
      }
    }
    out.push(pool[idx])
    pool.splice(idx, 1)
  }
  return out
}
